import React from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Add from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import Back from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { withStyles } from '@material-ui/core/styles';

import Header from './Header';
import api from '../api/api';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#3a5690ab",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

class Documents extends React.Component {
  constructor() {
    super();
    this.state = {
      value: 0,
      vhdReceivedDate: '',
      gateEntryNo: '',
      gateEntryDate: '',
      sapGateEntryNo: '',
      sapGateEntryDate: '',
      pcDcNo: '',
      pcDcDate: '',
      project: '',
      documentType: '',
      natureOfConsignment: '',
      boeNo: '',
      boeDate: '',
      lrNo: '',
      currencyType: '',
      invoiceAmount: '',
      exchangeRate: '',
      amount: '',
      invoiceNo: '',
      invoiceDate: '',
      vendor: '',
      poNo: '',
      poDate: '',
      poAmount: '',
      creditPeriod: '',
      userDepartment: '',
      userName: '',
      itemDescription: '',
      newProjectName: '',
      newDocumentType: '',
      newNatureOfConsignment: '',
      newCurrencyType: '',
      newVendorCode: '',
      newVendorName: '',
      newVendorContactNumber: '',
      newVendorAddress: '',
      newUserDept: '',
      projects: [],
      documentTypes: [],
      consignments: [],
      currencyTypes: [],
      vendors: [],
      userDeptList: [],
      projectVisible: false,
      documentTypeVisible: false,
      consignmentVisible: false,
      currencyTypeVisible: false,
      vendorVisible: false,
      userDeptVisible: false,
      userNameVisible: false,
      vendorCodeError: false,
      vendorNameError: false,
      userDeptError: false,
      currencyTypeError: false,
      consignmentNatureError: false,
      documentTypeError: false,
      projectNameError: false,
      inboundDeliveryNumber: '',
      inboundDeliveryDate: '',
      sapGrnNo: '',
      grnDate: '',
      noOfLinesInGr: '',
      sentToQcOn: '',
      recdFromQcOn: '',
      sentToUserOn: '',
      recdFromUserOn: '',
      userCertifiedAmount: '',
      submittedToFinOn: '',
      irNo: '',
      irDate: '',
      paymentDocumentNo: '',
      paymentDocumentDate: '',
      amountPaid: '',
      chqRtgsNo: '',
      chqDate: '',
      returnedFromFinOn: '',
      returnToVendor: '',
      dueDate: '',
      department: '',
      currentStatus: '',
      statusDate: '',
      tds: '',
      wct: '',
      advanceAdj: '',
      retention: '',
      otherDed: '',
      remarks: '',
      financeRemarks: '',
      currentStatusVisible: false,
      currentStatusList: [],
      newDocumentStatus: '',
      docStatusError: false,
      auditReportData: []
    };
    this.onProjectClick = this.onProjectClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onConsignmentClick = this.onConsignmentClick.bind(this);
    this.onCurrencyClick = this.onCurrencyClick.bind(this);
    this.onVendorClick = this.onVendorClick.bind(this);
    this.onUserDeptClick = this.onUserDeptClick.bind(this);
    this.onUserNameClick = this.onUserNameClick.bind(this);
    this.onCurrentStatusClick = this.onCurrentStatusClick.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  onProjectClick(event) {
    this.setState({projectVisible: true});
  }

  onDocumentClick(event) {
    this.setState({documentTypeVisible: true});
  }

  onConsignmentClick(event) {
    this.setState({consignmentVisible: true});
  }

  onCurrencyClick(event) {
    this.setState({currencyTypeVisible: true});
  }

  onVendorClick(event) {
    this.setState({vendorVisible: true});
  }

  onUserDeptClick(event) {
    this.setState({userDeptVisible: true});
  }

  onUserNameClick(event) {
    this.setState({userNameVisible: true});
  }

  onCurrentStatusClick(event) {
    this.setState({currentStatusVisible: true});
  }

  onHide(event) {
    this.setState ({
      projectVisible: false,
      documentTypeVisible: false,
      consignmentVisible: false,
      currencyTypeVisible: false,
      vendorVisible: false,
      userDeptVisible: false,
      currentStatusVisible: false
    })
  }

  onProjectAdd = (e) => {
    e.preventDefault();
    var projectName = this.state.newProjectName;
    if (projectName === '') {
      this.setState({
        projectNameError: true
      });
      return;
    }
    else {
      // Invoke post Project API
      api.postProject(projectName).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.project_id) {
              this.setState({
                projectVisible: false,
                project: res.project_id,
                newProjectName: ''
              });
              // Invoke get Projects list API
              api.getProjects().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.projects) {
                      let projectsList = [];
                      let keys = [];
                      for (var key in res.projects) {
                        projectsList.push({label: res.projects[key].project_name, value: res.projects[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        projects : projectsList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Projects.');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onDocumentTypeAdd = (e) => {
    e.preventDefault();
    var documentType = this.state.newDocumentType;
    if (documentType === '') {
      this.setState({
        documentTypeError: true
      });
      return;
    }
    else {
      // Invoke post Document Type API
      api.postDocumentType(documentType).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.document_id) {
              this.setState({
                documentTypeVisible: false,
                documentType: res.document_id,
                newDocumentType: ''
              });
              // Invoke get Document Types list API
              api.getDocumentTypes().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.document_types) {
                      let documentTypesList = [];
                      let keys = [];
                      for (var key in res.document_types) {
                        documentTypesList.push({label: res.document_types[key].document_type, value: res.document_types[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        documentTypes : documentTypesList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onConsignmentAdd = (e) => {
    e.preventDefault();
    var consignmentNature = this.state.newNatureOfConsignment;
    if (consignmentNature === '') {
      this.setState({
        consignmentNatureError: true
      });
      return;
    }
    else {
      // Invoke post Consignment API
      api.postConsignment(consignmentNature).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.consignment_id) {
              this.setState({
                consignmentVisible: false,
                natureOfConsignment: res.consignment_id,
                newNatureOfConsignment: ''
              });
              // Invoke Get Consignments list API
              api.getConsignments().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.consignments) {
                      let consignmentList = [];
                      let keys = [];
                      for (var key in res.consignments) {
                        consignmentList.push({label: res.consignments[key].nature_of_consignment, value: res.consignments[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        consignments : consignmentList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onCurrencyTypeAdd = (e) => {
    e.preventDefault();
    var currencyType = this.state.newCurrencyType;
    if (currencyType === '') {
      this.setState({
        currencyTypeError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postCurrencyType(currencyType).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.currency_type_id) {
              this.setState({
                currencyTypeVisible: false,
                currencyType: res.currency_type_id,
                newCurrencyType: ''
              });
              // Invoke Get Currency Types list API
              api.getCurrencyTypes().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.currency_types) {
                      let currencyTypeList = [];
                      let keys = [];
                      for (var key in res.currency_types) {
                        currencyTypeList.push({label: res.currency_types[key].currency_type, value: res.currency_types[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        currencyTypes : currencyTypeList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onVendorAdd = (e) => {
    e.preventDefault();
    var vendorCode = this.state.newVendorCode;
    var vendorName = this.state.newVendorName;
    var vendorContact = this.state.newVendorContactNumber;
    var vendorAddress = this.state.newVendorAddress;
    if (vendorCode === '') {
      this.setState({
        vendorCodeError: true
      });
      return;
    }
    else if(vendorName === '') {
      this.setState({
        vendorNameError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postNewVendor(vendorCode, vendorName, vendorContact, vendorAddress).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.vendor_id) {
              this.setState({
                vendorVisible: false,
                vendor: res.vendor_id,
                newVendorCode: '',
                newVendorName: '',
                newVendorContactNumber: '',
                newVendorAddress: ''
              });
              // Invoke Get Currency Types list API
              api.getVendors().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.vendors) {
                      let vendorsList = [];
                      let keys = [];
                      for (var key in res.vendors) {
                        vendorsList.push({label: res.vendors[key].vendor_name + ' (' + res.vendors[key].vendor_code +')' , value: res.vendors[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        vendors : vendorsList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onUserDeptAdd = (e) => {
    e.preventDefault();
    var userDept = this.state.newUserDept;
    if (userDept === '') {
      this.setState({
        userDeptError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postUserDept(userDept).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.department_id) {
              this.setState({
                userDeptVisible: false,
                userDepartment: res.department_id,
                newUserDept: ''
              });
              // Invoke Get User Department list API
              api.getUserDepts().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.user_departments) {
                      let userDeptList = [];
                      let keys = [];
                      for (var key in res.user_departments) {
                        userDeptList.push({label: res.user_departments[key].department_name, value: res.user_departments[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        userDeptList : userDeptList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }
  
  onCurrentStatusAdd = (e) => {
    e.preventDefault();
    var docStatus = this.state.newDocumentStatus;
    if (docStatus === '') {
      this.setState({
        docStatusError: true
      });
      return;
    }
    else {
      // Invoke post Currency Type API
      api.postDocumentStatus(docStatus).then((response) => {
        if(response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if(res.document_status_id) {
              this.setState({
                currentStatusVisible: false,
                currentStatus: res.document_status_id,
                newDocumentStatus: ''
              });
              // Invoke Get Documents Current Status list API
              api.getCurrentStatus().then((response) => {
                if(response.status >= 200 && response.status < 300) {
                  response.json().then((res) => {
                    if(res.document_status) {
                      let currentStatusList = [];
                      let keys = [];
                      for (var key in res.document_status) {
                        currentStatusList.push({label: res.document_status[key].status_value, value: res.document_status[key].id});
                        keys.push({key});
                      }
                      this.setState({
                        currentStatusList : currentStatusList
                      });
                    }
                    else {
                      alert('TODO:: Error Handling in Document Types..');
                    }
                  });
                }
                else {
                  alert('Error Handling in header1.');
                }
              });
            }
            else {
              alert('Something went wrong. Please try again later.');
            }
          });
        }
        else if (response.status === 601) {
          alert('Missing mandatory field(s)');
        }
      });
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleSubmit = (e) => {
    var companyCode = '001';
    var {vhdReceivedDate} = this.state;
    var {gateEntryNo} = this.state;
    var {gateEntryDate} = this.state;
    var {sapGateEntryNo} = this.state;
    var {sapGateEntryDate} = this.state;
    var {pcDcNo} = this.state;
    var {pcDcDate} = this.state;
    var {project} = this.state;
    var {documentType} = this.state;
    var {natureOfConsignment} = this.state;
    var {boeNo} = this.state;
    var {boeDate} = this.state;
    var {lrNo} = this.state;
    var {currencyType} = this.state;
    var {invoiceAmount} = this.state;
    var {exchangeRate} = this.state;
    var {amount} = this.state;
    var {invoiceNo} = this.state;
    var {invoiceDate} = this.state;
    var {vendor} = this.state;
    var {poNo} = this.state;
    var {poDate} = this.state;
    var {poAmount} = this.state;
    var {creditPeriod} = this.state;
    var {userDepartment} = this.state;
    var {userName} = this.state;
    var {itemDescription} = this.state;
    var {inboundDeliveryNumber} = this.state;
    var {inboundDeliveryDate} = this.state;
    var {sapGrnNo} = this.state;
    var {grnDate} = this.state;
    var {noOfLinesInGr} = this.state;
    var {sentToQcOn} = this.state;
    var {recdFromQcOn} = this.state;
    var {sentToUserOn} = this.state;
    var {recdFromUserOn} = this.state;
    var {userCertifiedAmount} = this.state;
    var {submittedToFinOn} = this.state;
    var {irNo} = this.state;
    var {irDate} = this.state;
    var {paymentDocumentNo} = this.state;
    var {paymentDocumentDate} = this.state;
    var {amountPaid} = this.state;
    var {chqRtgsNo} = this.state;
    var {chqDate} = this.state;
    var {returnedFromFinOn} = this.state;
    var {returnToVendor} = this.state;
    var {dueDate} = this.state;
    var {department} = this.state;
    var {currentStatus} = this.state;
    var {statusDate} = this.state;
    var {tds} = this.state;
    var {wct} = this.state;
    var {advanceAdj} = this.state;
    var {retention} = this.state;
    var {otherDed} = this.state;
    var {remarks} = this.state;
    var {financeRemarks} = this.state;
    var documentNumber = this.props.match.params.documentNumber;
    // Invoke put Document API
    api.putDocument(companyCode, documentNumber, vhdReceivedDate, gateEntryNo, gateEntryDate, sapGateEntryNo, sapGateEntryDate, pcDcNo, pcDcDate, project, 
                     documentType, natureOfConsignment, boeNo, boeDate, lrNo, currencyType, invoiceAmount, exchangeRate, amount, invoiceNo, 
                     invoiceDate, vendor, poNo, poDate, poAmount, creditPeriod, userDepartment, userName, itemDescription, inboundDeliveryNumber,
                     inboundDeliveryDate, sapGrnNo, grnDate, noOfLinesInGr, sentToQcOn, recdFromQcOn, sentToUserOn, recdFromUserOn, userCertifiedAmount,
                     submittedToFinOn, irNo, irDate, paymentDocumentNo, paymentDocumentDate, amountPaid, chqRtgsNo, chqDate, returnedFromFinOn, returnToVendor,
                     dueDate, department, currentStatus, statusDate, tds, wct, advanceAdj, retention, otherDed, remarks, financeRemarks).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.status === 'Success') {
            alert('Document Updated Successfully!!');
            // Invoke get Audit Report list API
            api.getAuditReportList(companyCode, documentNumber).then((response) => {
              if(response.status >= 200 && response.status < 300) {
                response.json().then((res) => {
                  if(res) {
                    this.setState({
                      auditReportData : res.Audit_history
                    });
                  }
                  else {
                    alert('TODO:: Error Handling in Projects..');
                  }
                });
              }
              else {
                alert('Error Handling in header1.');
              }
            });
          }
          else {
            alert('Something went wrong. Please try again later.');
          }
        });
      }
      else if (response.status === 601) {
        alert('Missing mandatory field(s)');
      }
    });
  }

  componentWillMount() {



    var companyCode = '001';
    var documentNumber = this.props.match.params.documentNumber;
    // Get Document Details API
    api.getDocumentDetailss(companyCode, documentNumber).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.documents) {
            this.setState({
              vhdReceivedDate: res.documents[0].vhd_received_date === '' ? '' : res.documents[0].vhd_received_date.split("-").reverse().join("-"),
              gateEntryNo: res.documents[0].gate_entry_no,
              gateEntryDate:  res.documents[0].gate_entry_date === '' ? '' : res.documents[0].gate_entry_date.split("-").reverse().join("-"),
              sapGateEntryNo: res.documents[0].sap_gate_entry_no,
              sapGateEntryDate: res.documents[0].sap_gate_entry_date === '' ? '' : res.documents[0].sap_gate_entry_date.split("-").reverse().join("-"),
              pcDcNo: res.documents[0].pc_no_dc_no,
              pcDcDate: res.documents[0].pc_dc_date === '' ? '' : res.documents[0].pc_dc_date.split("-").reverse().join("-"),
              project: res.documents[0].project,
              documentType: res.documents[0].document_type,
              natureOfConsignment: res.documents[0].nature_of_consignment,
              boeNo: res.documents[0].boe_no,
              boeDate: res.documents[0].boe_date === '' ? '' : res.documents[0].boe_date.split("-").reverse().join("-"),
              lrNo: res.documents[0].lr_no,
              currencyType: res.documents[0].currency_type_id,
              invoiceAmount: res.documents[0].amt_invoice_currency,
              exchangeRate: res.documents[0].exchange_rate,
              amount: res.documents[0].amt_inr,
              invoiceNo: res.documents[0].invoice_no,
              invoiceDate: res.documents[0].invoice_date === '' ? '' : res.documents[0].invoice_date.split("-").reverse().join("-"),
              vendor: res.documents[0].vendor_id,
              poNo: res.documents[0].po_no,
              poDate: res.documents[0].po_date === '' ? '' : res.documents[0].po_date.split("-").reverse().join("-"),
              poAmount: res.documents[0].po_amount,
              creditPeriod: res.documents[0].credit_period,
              userDepartment: res.documents[0].user_dept,
              userName: res.documents[0].user_name,
              itemDescription: res.documents[0].item_description,
              inboundDeliveryNumber: res.documents[0].inbound_delivery_number,
              inboundDeliveryDate: res.documents[0].inbound_delivery_date === '' ? '' : res.documents[0].inbound_delivery_date.split("-").reverse().join("-"),
              sapGrnNo: res.documents[0].sap_grn_no,
              grnDate: res.documents[0].grn_date === '' ? '' : res.documents[0].grn_date.split("-").reverse().join("-"),
              noOfLinesInGr: res.documents[0].no_of_lines_in_gr,
              sentToQcOn: res.documents[0].sent_to_qc_on === '' ? '' : res.documents[0].sent_to_qc_on.split("-").reverse().join("-"),
              recdFromQcOn: res.documents[0].recd_from_qc_on === '' ? '' : res.documents[0].recd_from_qc_on.split("-").reverse().join("-"),
              sentToUserOn: res.documents[0].sent_to_user_on === '' ? '' : res.documents[0].sent_to_user_on.split("-").reverse().join("-"),
              recdFromUserOn: res.documents[0].recd_from_user_on === '' ? '' : res.documents[0].recd_from_user_on.split("-").reverse().join("-"),
              userCertifiedAmount: res.documents[0].user_certified_amount,
              submittedToFinOn: res.documents[0].submitted_to_fin_on === '' ? '' : res.documents[0].submitted_to_fin_on.split("-").reverse().join("-"),
              irNo: res.documents[0].ir_no,
              irDate: res.documents[0].ir_date === '' ? '' : res.documents[0].ir_date.split("-").reverse().join("-"),
              paymentDocumentNo: res.documents[0].payment_document_no,
              paymentDocumentDate: res.documents[0].payment_document_date === '' ? '' : res.documents[0].payment_document_date.split("-").reverse().join("-"),
              amountPaid: res.documents[0].amount_paid,
              chqRtgsNo: res.documents[0].chq_rtgs_no,
              chqDate: res.documents[0].chq_date === '' ? '' : res.documents[0].chq_date.split("-").reverse().join("-"),
              returnedFromFinOn: res.documents[0].returned_from_fin_on === '' ? '' : res.documents[0].returned_from_fin_on.split("-").reverse().join("-"),
              returnToVendor: res.documents[0].return_to_vendor === '' ? '' : res.documents[0].return_to_vendor.split("-").reverse().join("-"),
              dueDate: res.documents[0].due_date === '' ? '' : res.documents[0].due_date.split("-").reverse().join("-"),
              department: res.documents[0].department_id,
              currentStatus: res.documents[0].doc_current_status_id,
              statusDate: res.documents[0].status_date === '' ? '' : res.documents[0].status_date.split("-").reverse().join("-"),
              tds: res.documents[0].tds,
              wct: res.documents[0].wct,
              advanceAdj: res.documents[0].advance_adj,
              retention: res.documents[0].retention,
              otherDed: res.documents[0].other_ded,
              remarks: res.documents[0].remarks,
              financeRemarks: res.documents[0].finance_remarks
            })
          }
          else {
            this.setState({
              error: "Something went wrong. Please contact site administrator"
            });
          }
       });
      }
    });
    // Invoke get Projects list API
    api.getProjects().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.projects) {
            let projectsList = [];
            let keys = [];
            for (var key in res.projects) {
              projectsList.push({value: res.projects[key].id, label: res.projects[key].project_name});
              keys.push({key});
            }
            this.setState({
              projects : projectsList
            });
          }
          else {
            alert('TODO:: Error Handling in Projects..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke get Document Types list API
    api.getDocumentTypes().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.document_types) {
            let documentTypesList = [];
            let keys = [];
            for (var key in res.document_types) {
              documentTypesList.push({label: res.document_types[key].document_type, value: res.document_types[key].id});
              keys.push({key});
            }
            this.setState({
              documentTypes : documentTypesList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Consignments list API
    api.getConsignments().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.consignments) {
            let consignmentList = [];
            let keys = [];
            for (var key in res.consignments) {
              consignmentList.push({label: res.consignments[key].nature_of_consignment, value: res.consignments[key].id});
              keys.push({key});
            }
            this.setState({
              consignments : consignmentList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Currency Types list API
    api.getCurrencyTypes().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.currency_types) {
            let currencyTypeList = [];
            let keys = [];
            for (var key in res.currency_types) {
              currencyTypeList.push({label: res.currency_types[key].currency_type, value: res.currency_types[key].id});
              keys.push({key});
            }
            this.setState({
              currencyTypes : currencyTypeList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Currency Types list API
    api.getVendors().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.vendors) {
            let vendorsList = [];
            let keys = [];
            for (var key in res.vendors) {
              vendorsList.push({label: res.vendors[key].vendor_name + ' (' + res.vendors[key].vendor_code +')' , value: res.vendors[key].id});
              keys.push({key});
            }
            this.setState({
              vendors : vendorsList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get User Department list API
    api.getUserDepts().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.user_departments) {
            let userDeptList = [];
            let keys = [];
            for (var key in res.user_departments) {
              userDeptList.push({label: res.user_departments[key].department_name, value: res.user_departments[key].id});
              keys.push({key});
            }
            this.setState({
              userDeptList : userDeptList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Documents Current Status list API
    api.getCurrentStatus().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.document_status) {
            let currentStatusList = [];
            let keys = [];
            for (var key in res.document_status) {
              currentStatusList.push({label: res.document_status[key].status_value, value: res.document_status[key].id});
              keys.push({key});
            }
            this.setState({
              currentStatusList : currentStatusList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke get Audit Report list API
    api.getAuditReportList(companyCode, documentNumber).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res) {
            this.setState({
              auditReportData : res.Audit_history
            });
          }
          else {
            alert('TODO:: Error Handling in Projects..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
  }

  render() {
    const { value } = this.state;
    return (
			<div>
				<Header />
        <AppBar position="sticky" color="default">
          <Tabs
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
          >
            <Tab label="Data Collection" />
            <Tab label="Store" />
            <Tab label="Quality" />
            <Tab label="User" />
            <Tab label="Finance" />
            <Tab label="Other" />
            <Tab label="Audit" />
          </Tabs>
        </AppBar>
        {value === 0 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="companyName"
                  name="companyName"
                  label="Company Name"
                  defaultValue= "Company One"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.vhdReceivedDate}
                  id="vhdDate"
                  name="vhdReceivedDate"
                  label="VHD Received Date"
                  type="date"
                  fullWidth
                  autoFocus={true}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({vhdReceivedDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.gateEntryNo}
                  id="gateEntryNo"
                  name="gateEntryNo"
                  label="Gate Entry No"
                  fullWidth
                  onChange={(e) => this.setState({gateEntryNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.gateEntryDate}
                  id="gateEntryDate"
                  name="gateEntryDate"
                  label="Gate Entry Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({gateEntryDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.sapGateEntryNo}
                  id="sapGateEntryNo"
                  name="sapGateEntryNo"
                  label="SAP Gate entry No"
                  fullWidth
                  onChange={(e) => this.setState({sapGateEntryNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.sapGateEntryDate}
                  id="sapGateEntryDate"
                  name="sapGateEntryDate"
                  label="SAP Gate Entry Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({sapGateEntryDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.pcDcNo}
                  id="pcDcNo"
                  name="pcDcNo"
                  label="PC No/Dc No"
                  fullWidth
                  onChange={(e) => this.setState({pcDcNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.pcDcDate}
                  id="pcDcDate"
                  name="pcDcDate"
                  label="PC/DC Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({pcDcDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.project}
                  id="project"
                  name="project"
                  label="Project"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onProjectClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({project: e.target.value})}}
                >
                  {this.state.projects.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.documentType}
                  id="documentType"
                  name="documentType"
                  label="Document Type"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onDocumentClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({documentType: e.target.value})}}
                >
                  {this.state.documentTypes.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.natureOfConsignment}
                  id="natureOfConsignment"
                  name="natureOfConsignment"
                  label="Nature of Consignment"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onConsignmentClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({natureOfConsignment: e.target.value})}}
                >
                  {this.state.consignments.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.boeNo}
                  id="boeNo"
                  name="boeNo"
                  label="BOE No"
                  fullWidth
                  onChange={(e) => this.setState({boeNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.boeDate}
                  id="boeDate"
                  name="boeDate"
                  label="BOE Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({boeDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.lrNo}
                  id="lrNo"
                  name="lrNo"
                  label="LR No"
                  fullWidth
                  onChange={(e) => this.setState({lrNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.currencyType}
                  id="currencyType"
                  name="currencyType"
                  label="Currency Type"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onCurrencyClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({currencyType: e.target.value})}}
                >
                  {this.state.currencyTypes.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.invoiceAmount}
                  id="invoiceAmount"
                  name="invoiceAmount"
                  label="Amt (Invoice Currency)"
                  fullWidth
                  onChange={(e) => this.setState({invoiceAmount: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.exchangeRate}
                  id="exchangeRate"
                  name="exchangeRate"
                  label="Exchange Rate"
                  fullWidth
                  onChange={(e) => this.setState({exchangeRate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.amount}
                  id="amount"
                  name="amount"
                  label="Amt (INR)"
                  fullWidth
                  onChange={(e) => this.setState({amount: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.invoiceNo}
                  id="invoiceNo"
                  name="invoiceNo"
                  label="Invoice No"
                  fullWidth
                  onChange={(e) => this.setState({invoiceNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.invoiceDate}
                  id="invoiceDate"
                  name="invoiceDate"
                  label="Invoice Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({invoiceDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.vendor}
                  id="vendor"
                  name="vendor"
                  label="Vendor"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onVendorClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({vendor: e.target.value})}}
                >
                  {this.state.vendors.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.poNo}
                  id="poNo"
                  name="poNo"
                  label="PO No"
                  fullWidth
                  onChange={(e) => this.setState({poNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.poDate}
                  id="poDate"
                  name="poDate"
                  label="PO Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({poDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.poAmount}
                  id="poAmount"
                  name="poAmount"
                  label="PO Amount"
                  fullWidth
                  onChange={(e) => this.setState({poAmount: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.creditPeriod}
                  id="creditPeriod"
                  name="creditPeriod"
                  label="Credit Period"
                  fullWidth
                  onChange={(e) => this.setState({creditPeriod: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.userDepartment}
                  id="userDepartment"
                  name="userDepartment"
                  label="User Dept"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onUserDeptClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({userDepartment: e.target.value})}}
                >
                  {this.state.userDeptList.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.userName}
                  id="userName"
                  name="userName"
                  label="User Name"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onUserNameClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({userName: e.target.value})}}
                >
                  <MenuItem key="1" value="Hemanth">Hemanth</MenuItem>
                  <MenuItem key="2" value="Suresh">Suresh</MenuItem>
                  <MenuItem key="3" value="Rajesh">Rajesh</MenuItem>
                  <MenuItem key="4" value="Mahesh">Mahesh</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={this.state.itemDescription}
                  id="itemDescription"
                  name="itemDescription"
                  label="Item Description"
                  fullWidth
                  multiline
                  onChange={(e) => this.setState({itemDescription: e.target.value})}
                />
              </Grid>
            </Grid><br/>
            <div className="icon-bar">
              <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
                <SaveIcon />&nbsp;&nbsp;Submit
              </Button>&nbsp;&nbsp;&nbsp;&nbsp;
              <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} href="/" >
                <Back />&nbsp;&nbsp;Back
              </Button>
            </div>
          </Paper>
        }
        {value === 1 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.inboundDeliveryNumber}
                  id="inboundDeliveryNumber"
                  name="inboundDeliveryNumber"
                  label="Inbound delivery number"
                  fullWidth
                  autoFocus={true}
                  onChange={(e) => this.setState({inboundDeliveryNumber: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.inboundDeliveryDate}
                  id="inboundDeliveryDate"
                  name="inboundDeliveryDate"
                  label="Inbound delivery date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({inboundDeliveryDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.sapGrnNo}
                  id="sapGrnNo"
                  name="sapGrnNo"
                  label="SAP GRN No"
                  fullWidth
                  onChange={(e) => this.setState({sapGrnNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.grnDate}
                  id="grnDate"
                  name="grnDate"
                  label="GRN Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({grnDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.noOfLinesInGr}
                  id="noOfLinesInGr"
                  name="noOfLinesInGr"
                  label="No. Of Lines in GR"
                  fullWidth
                  onChange={(e) => this.setState({noOfLinesInGr: e.target.value})}
                />
              </Grid>
            </Grid><br/>
            <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
              <SaveIcon />&nbsp;&nbsp;Submit
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} href="/" >
              <Back />&nbsp;&nbsp;Back
            </Button>
          </Paper>
        }
        {value === 2 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.sentToQcOn}
                  id="sentToQcOn"
                  name="sentToQcOn"
                  label="Sent to QC on"
                  type="date"
                  fullWidth
                  autoFocus={true}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({sentToQcOn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.recdFromQcOn}
                  id="recdFromQcOn"
                  name="recdFromQcOn"
                  label="Recd from QC on"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({recdFromQcOn: e.target.value})}
                />
              </Grid>
            </Grid><br/>
            <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
              <SaveIcon />&nbsp;&nbsp;Submit
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} href="/" >
              <Back />&nbsp;&nbsp;Back
            </Button>
          </Paper>
        }
        {value === 3 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.sentToUserOn}
                  id="sentToUserOn"
                  name="sentToUserOn"
                  label="Sent to User on"
                  type="date"
                  fullWidth
                  autoFocus={true}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({sentToUserOn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.recdFromUserOn}
                  id="recdFromUserOn"
                  name="recdFromUserOn"
                  label="Recd From User on"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({recdFromUserOn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.userCertifiedAmount}
                  id="userCertifiedAmount"
                  name="userCertifiedAmount"
                  label="User certified amount"
                  fullWidth
                  onChange={(e) => this.setState({userCertifiedAmount: e.target.value})}
                />
              </Grid>
            </Grid><br/>
            <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
              <SaveIcon />&nbsp;&nbsp;Submit
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} href="/" >
              <Back />&nbsp;&nbsp;Back
            </Button>
          </Paper>
        }
        {value === 4 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.submittedToFinOn}
                  id="submittedToFinOn"
                  name="submittedToFinOn"
                  label="Submitted to Fin on"
                  type="date"
                  fullWidth
                  autoFocus={true}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({submittedToFinOn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.irNo}
                  id="irNo"
                  name="irNo"
                  label="IR No"
                  fullWidth
                  onChange={(e) => this.setState({irNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.irDate}
                  id="irDate"
                  name="irDate"
                  label="IR Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({irDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.paymentDocumentNo}
                  id="paymentDocumentNo"
                  name="paymentDocumentNo"
                  label="Payment Document No"
                  fullWidth
                  onChange={(e) => this.setState({paymentDocumentNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.paymentDocumentDate}
                  id="paymentDocumentDate"
                  name="paymentDocumentDate"
                  label="Payment Document Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({paymentDocumentDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.amountPaid}
                  id="amountPaid"
                  name="amountPaid"
                  label="Amount Paid"
                  fullWidth
                  onChange={(e) => this.setState({amountPaid: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.chqRtgsNo}
                  id="chqRtgsNo"
                  name="chqRtgsNo"
                  label="Chq / RTGS No"
                  fullWidth
                  onChange={(e) => this.setState({chqRtgsNo: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.chqDate}
                  id="chqDate"
                  name="chqDate"
                  label="Chq Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({chqDate: e.target.value})}
                />
              </Grid>
            </Grid><br/>
            <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
              <SaveIcon />&nbsp;&nbsp;Submit
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} href="/" >
              <Back />&nbsp;&nbsp;Back
            </Button>
          </Paper>
        }
        {value === 5 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Grid container spacing={24} style={{width:'100%'}}>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.returnedFromFinOn}
                  id="returnedFromFinOn"
                  name="returnedFromFinOn"
                  label="Returned From Fin on"
                  type="date"
                  fullWidth
                  autoFocus={true}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({returnedFromFinOn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.returnToVendor}
                  id="returnToVendor"
                  name="returnToVendor"
                  label="Return To Vendor"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({returnToVendor: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.dueDate}
                  id="dueDate"
                  name="dueDate"
                  label="Due Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({dueDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.department}
                  id="department"
                  name="department"
                  label="Department"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onUserDeptClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({department: e.target.value})}}
                >
                  {this.state.userDeptList.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.currentStatus}
                  id="currentStatus"
                  name="currentStatus"
                  label="Current Status"
                  select={true}
                  fullWidth
                  InputProps={{
                    endAdornment:(
                      <InputAdornment position="end">
                        <IconButton onClick={this.onCurrentStatusClick} color="primary">
                          <Add/>
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {this.setState({currentStatus: e.target.value})}}
                >
                  {this.state.currentStatusList.map((option,id) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.statusDate}
                  id="statusDate"
                  name="statusDate"
                  label="Status Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => this.setState({statusDate: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.tds}
                  id="tds"
                  name="tds"
                  label="TDS"
                  fullWidth
                  onChange={(e) => this.setState({tds: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.wct}
                  id="wct"
                  name="wct"
                  label="WCT"
                  fullWidth
                  onChange={(e) => this.setState({wct: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.advanceAdj}
                  id="advanceAdj"
                  name="advanceAdj"
                  label="Advance adj"
                  fullWidth
                  onChange={(e) => this.setState({advanceAdj: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.retention}
                  id="retention"
                  name="retention"
                  label="Retention"
                  fullWidth
                  onChange={(e) => this.setState({retention: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  value={this.state.otherDed}
                  id="otherDed"
                  name="otherDed"
                  label="Other Ded"
                  fullWidth
                  onChange={(e) => this.setState({otherDed: e.target.value})}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={this.state.remarks}
                  id="remarks"
                  name="remarks"
                  label="Remarks"
                  fullWidth
                  multiline
                  onChange={(e) => this.setState({remarks: e.target.value})}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={this.state.financeRemarks}
                  id="financeRemarks"
                  name="financeRemarks"
                  label="Finance Remarks"
                  fullWidth
                  multiline
                  onChange={(e) => this.setState({financeRemarks: e.target.value})}
                />
              </Grid>
            </Grid><br/>
            <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
              <SaveIcon />&nbsp;&nbsp;Submit
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} href="/" >
              <Back />&nbsp;&nbsp;Back
            </Button>
          </Paper>
        }
        {value === 6 &&
          <Paper style={{padding: '10px', margin: '10px'}}>
            <Table>
              <TableHead>
                <TableRow>
                  <CustomTableCell style={{width: '100px'}}>User Department</CustomTableCell>
                  <CustomTableCell style={{width: '100px'}} align="right">User Name</CustomTableCell>
                  <CustomTableCell style={{width: '100px'}} align="right">No of Days</CustomTableCell>
                  <CustomTableCell style={{width: '100px'}} align="right">From Date</CustomTableCell>
                  <CustomTableCell style={{width: '100px'}} align="right">To Date</CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.auditReportData.map(row => (
                  <TableRow key={row.id}>
                    <CustomTableCell component="th" scope="row">{row.user_dept}</CustomTableCell>
                    <CustomTableCell align="right">{row.user_name}</CustomTableCell>
                    <CustomTableCell align="right">{row.time}</CustomTableCell>
                    <CustomTableCell align="right">{row.from_date}</CustomTableCell>
                    <CustomTableCell align="right">{row.to_date}</CustomTableCell>
                  </TableRow>
                ))}
                {this.state.auditReportData.length === 0 &&
                  <TableRow key="0">
                    <CustomTableCell>
                      <span style={{display: 'flex', margin: '12px'}}>No audit data available</span>
                    </CustomTableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </Paper>
        }
        <Dialog open={this.state.projectVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Project Name</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              id="newProjectName"
              label="Project Name"
              fullWidth
              required
              error={this.state.projectNameError}
              onChange={(e) => this.setState({newProjectName: e.target.value, projectNameError:false})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onProjectAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.documentTypeVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Document Type</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              id="newDocumentType"
              label="Document Type"
              fullWidth
              required
              error={this.state.documentTypeError}
              onChange={(e) => this.setState({newDocumentType: e.target.value, documentTypeError: false})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onDocumentTypeAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.consignmentVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add Nature of Consignment</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              id="newNatureOfConsignment"
              label="Nature of Consignment"
              fullWidth
              required
              error={this.state.consignmentNatureError}
              onChange={(e) => this.setState({newNatureOfConsignment: e.target.value, consignmentNatureError: false})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onConsignmentAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.currencyTypeVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Currency Type</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              id="newCurrencyType"
              label="Currency Type"
              fullWidth
              required
              error={this.state.currencyTypeError}
              onChange={(e) => this.setState({newCurrencyType: e.target.value, currencyTypeError: false})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onCurrencyTypeAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.vendorVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Vendor</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus={true}
              id="newVendorCode"
              label="Vendor Code"
              fullWidth
              required
              error={this.state.vendorCodeError}
              onChange={(e) => this.setState({newVendorCode: e.target.value, vendorCodeError: false})}
            />
            <TextField
              id="newVendorName"
              label="Vendor Name"
              fullWidth
              required
              error={this.state.vendorNameError}
              onChange={(e) => this.setState({newVendorName: e.target.value, vendorNameError: false})}
            />
            <TextField
              id="newVendorContactNumber"
              label="Vendor Contact Number"
              fullWidth
              onChange={(e) => this.setState({newVendorContactNumber: e.target.value})}
            />
            <TextField
              id="newVendorAddress"
              label="Vendor Address"
              fullWidth
              onChange={(e) => this.setState({newVendorAddress: e.target.value})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onVendorAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.userDeptVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New User Department</DialogTitle>
          <DialogContent>
            <TextField
              id="newUserDept"
              label="User Dept"
              fullWidth
              autoFocus={true}
              error={this.state.userDeptError}
              onChange={(e) => this.setState({newUserDept: e.target.value, userDeptError: false})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onUserDeptAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.currentStatusVisible} fullWidth >
          <DialogTitle style={{backgroundColor: '#c7c7c75c', padding: '18px', marginBottom: '10px'}} id="form-dialog-title">Add New Document Status</DialogTitle>
          <DialogContent>
            <TextField
              id="newDocumentStatus"
              label="Current Status"
              fullWidth
              autoFocus={true}
              error={this.state.docStatusError}
              onChange={(e) => this.setState({newDocumentStatus: e.target.value, docStatusError: false})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onHide} color="primary">
              Cancel
            </Button>
            <Button onClick={this.onCurrentStatusAdd} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(Documents);


// WEBPACK FOOTER //
// ./src/components/DocumentUpdate.js